import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface TractionBatteryCablesProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function TractionBatteryCables(props: TractionBatteryCablesProps) {
  return (
    <svg
      width="670"
      height="28"
      viewBox="0 0 670 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{top: 237, left: 327}}
      onClick={props.onClick}
    >
      <path
        d="M3 1C5 1 5 3 5 3V4H7C9 4 9 6 9 6V8H43V6C43 6 43 4 45 4H47V3C47 3 47 1 49 1H52V27H49C47 27 47 25 47 25V24H45C43 24 43 22 43 22V20H9V22C9 22 9 24 7 24H5V25C5 25 5 27 3 27H0V1H3Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M616 1C618 1 618 3 618 3V4H620C622 4 622 6 622 6V8H661V6C661 6 661 4 663 4H665V3C665 3 665 1 667 1H670V27H667C665 27 665 25 665 25V24H663C661 24 661 22 661 22V20H622V22C622 22 622 24 620 24H618V25C618 25 618 27 616 27H613V1H616Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M0 27H3C5 27 5 25 5 25V24M0 1H3C5 1 5 3 5 3V4M5 24H7C9 24 9 22 9 22V20M5 24V4M5 4H7C9 4 9 6 9 6V8M52 27H49C47 27 47 25 47 25V24M52 1H49C47 1 47 3 47 3V4M47 24H45C43 24 43 22 43 22V20M47 24V4M47 4H45C43 4 43 6 43 6V8M9 8H43M9 8V20M43 8V20M9 20H43M613 27H616C618 27 618 25 618 25V24M613 1H616C618 1 618 3 618 3V4M618 24H620C622 24 622 22 622 22V20M618 24V4M618 4H620C622 4 622 6 622 6V8M670 27H667C665 27 665 25 665 25V24M670 1H667C665 1 665 3 665 3V4M665 24H663C661 24 661 22 661 22V20M665 24V4M665 4H663C661 4 661 6 661 6V8M622 8H661M622 8V20M661 8V20M622 20H661"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M9 11H43M9 14H43M9 17H43M622 11H661M622 14H661M622 17H661"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </svg>
  );
}
